import { render, staticRenderFns } from "./QuarterMarks.vue?vue&type=template&id=553144f3&"
import script from "./QuarterMarks.vue?vue&type=script&lang=js&"
export * from "./QuarterMarks.vue?vue&type=script&lang=js&"
import style0 from "./QuarterMarks.vue?vue&type=style&index=0&id=553144f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports